import { property } from '@wonderlandengine/api/decorators.js';
import { Component, Material } from '@wonderlandengine/api';

/**
 * Grille Description:
 */
export class GrilleDescription extends Component {
	static TypeName = 'grille-description';

	//-----------------------------------------------------------------------------------------
	// Inspector Variables:
	//-----------------------------------------------------------------------------------------

	@property.string('')
	grilleId: string = '';

	@property.material()
	grilleMaterial: Material | null = null;
}